import { setCookieCSR } from '@/app/api/CSR/setCookieCSR'
import { DEFAULT_COOKIE_STORE_DAYS } from '@/utils/constants'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'
import { Store } from '~types/index'

const saveStoreData = async (store: Store) => {
  setCookieCSR('_IL-storeId', store?.id, DEFAULT_COOKIE_STORE_DAYS)
  setCookieCSR(
    '_IL-storeReference',
    store?.code || '',
    DEFAULT_COOKIE_STORE_DAYS
  )
  if (typeof window !== 'undefined') {
    window?.localStorage?.setItem('selectedStore', JSON.stringify(store))
  }
  selectedMutations.updateStore(store)
}

export default saveStoreData
